export default {
  // Main Layout
  mainLayout: {
    title: 'App Template',
    greeting: 'Hello, {user}!',
    changePassword: 'Change Password',
    editProfile: 'Edit Profile',
    logout: 'Logout',
    adminActions: 'Admin Actions',
    linkAddRetailStore: 'Retail Store',
    linkDashboard: 'Dashboard',
    linkDealerLocator: 'Dealer Locator',
    linkManageUsers: 'Manage Users',
    linkManageRoles: 'Manage Roles',
    linkManageEmails: 'Manage Emails',
    linkManageVehicles: 'My RV',
    linkNotifications: 'Notifications',
    linkInformationalVideos: 'How-To Videos',
    linkUnitInformation: 'Unit Information',
    linkSolar: 'Solar',
    linkSupport: 'Support',
    linkFaq: 'FAQ',
    linkChecklists: 'Checklists',
    linkBlogPosts: 'Campfire Stories',
    linkPodcasts: 'Podcasts',
    linkOwnersClubLink: "Owner's Club",
    linkOwnersForumLink: "Owner's Forum",
  },

  // 404 Page
  notFound: {
    message: 'Oops. Nothing here...',
    homeLink: 'Go Home'
  },

  // Login Page
  login: {
    title: 'Login',
    username: 'Email *',
    usernameRequired: 'Email is requried',
    password: 'Password *',
    passwordRequired: 'Password is required',
    rememberUsername: 'Remember Email',
    forgotPassword: 'Forgot password?',
    register: 'Register',
    signIn: 'Sign in'
  },

  /////////////////////////////////////////////////////////////////////////////////
  // Account

  changePassword: {
    title: 'Change Password',
    instructions: 'Please enter a new password:',
    currentPassword: 'Current Password *',
    currentPasswordRequired: 'Current Password is requried',
    newPassword: 'New Password *',
    newPasswordRequired: 'New Password is required',
    confirmNewPassword: 'Confirm New Password *',
    confirmNewPasswordRequired: 'Confirm New Password is required',
    successMessage: 'Success! Your password has been changed.'
  },

  confirmEmail: {
    title: 'Confirm Email',
    loadingMessage: 'Confirming your email...',
    successMessage: 'Success! Your email has been confirmed.',
    continueToLogin: 'Continue to login',
    invalidTokenTitle: 'Confirm Email Token Invalid',
    invalidTokenMessage: 'A new confirmation email has been sent. Please follow the link and try again.',
  },

  editProfile: {
    title: 'Edit Profile',
    saveChanges: 'Save Changes',
    resetProfile: 'Reset',
    successMessage: 'Success! Your profile has been updated.',
    accountInfoTitle: 'Account Information',
    notifPrefsTitle: 'Notification Preferences',
    emailNotifLabel: 'Email Notifications',
    pushNotifLabel: 'Push Notifications',
  },

  forgotPassword: {
    title: 'Forgot Password',
    instructions: "Please enter your account's current email address:",
    email: 'Email *',
    emailRequired: 'Email is requried',
    recover: 'Recover',
    successMessage: 'An email has been sent to {email} if this account exists.',
  },

  register: {
    title: 'Register',
    firstName: 'First Name *',
    firstNameRequired: 'First Name is requried',
    lastName: 'Last Name *',
    lastNameRequired: 'Last Name is requried',
    email: 'Your Email *',
    emailRequired: 'Email is requried',
    phone: 'Phone Number *',
    phoneError: 'Please enter a valid phone number',
    streetAddress: 'Street Address *',
    streetAddressRequired: 'Street Address is required',
    city: 'City *',
    cityRequired: 'City is required',
    zip: 'Zip / Postal Code *',
    zipRequired: 'Zip / Postal Code is required',
    state: 'State / Province *',
    stateRequired: 'State / Province is required',
    country: 'Country *',
    countryRequired: 'Country is required',
    password: 'Password *',
    passwordRequired: 'Password is requried',
    confirmPassword: 'Confirm Password *',
    confirmPasswordRequired: 'Confirm Password is required',
    passwordDoesNotMatch: 'Password and Confirm Password must match.',
    successMessage:
      'A confirmation email has been sent to {email}. Please follow the link to complete the registration process.',
    termsAndConditionsMessage: "By clicking Agree & Register you agree to {companyDisplayName}' ",
    agreeAndRegister: 'Agree & Register',
    invitationSuccessMessage: 'Your account has been created',
    successTitle: 'Registration Success!',
  },

  resetPassword: {
    title: 'Reset Password',
    instructions: 'Please enter a new password:',
    newPassword: 'New Password *',
    newPasswordRequired: 'New Password is required',
    confirmNewPassword: 'Confirm New Password *',
    confirmNewPasswordRequired: 'Confirm New Password is required',
    successMessage: 'Success! Your password has been changed.',
    passwordDoesNotMatch: 'Password and Confirm Password must match.',
    invalidTokenTitle: 'Reset Password Token Invalid',
    invalidTokenMessage: 'Token invalid, please request for a new token.',
  },

  termsAndConditions: {
    termsAndConditionsMessage:
      "Our {name} have been updated. By clicking Agree & Continue you agree to {companyDisplayName}' updated ",
    agreeAndContinue: 'Agree & Continue',
  },

  //////////////////////////////////////////////////////////////////////////////////
  // Consumer

  dashboard: {
    vehicleInformation: 'RV Information',
    notifications: 'Notifications',
    newNotifications: 'New Notifications',
    seeAllNotifications: 'See All Notifications',
    serviceInformation: 'Service Information',
    salesOrders: 'Sales Orders',
    claims: 'Claims',
    recalls: 'Recalls',
    seeServiceInformation: 'See Service Information',
    primaryRv: 'Primary RV',
    noActiveRvText: 'In order to view dashboard information, please add an RV.',
    addRVDirectionsStart: 'To add an RV, ',
    goToMyRV: 'Go to "My RV"',
    addRVDirectionsEnd: ' in the navigation menu.',
  },

  splashScreen: {
    carouselMessages: {
      manageVehicles: 'Manage your RV, check on warranty, claims, and orders',
      signUpAlerts: 'Sign up for alerts, notification, and messaging',
      nearestDealer: 'Find nearest dealer and service center',
    },
  },

  registerVin: {
    title: 'Add RV',
    resubmitTitle: 'Resubmit RV',
    lastName: 'Last Name *',
    lastNameRequired: 'Last Name is required',
    purchaseDate: 'Purchase Date *',
    purchaseDateRequired: 'Purchase Date is requried',
    purchaseDateCannotBeInFuture: 'Purchase Date cannot be a date in the future',
    formInstructions: 'Please enter the same information that was provided to the dealer when the RV was purchased.',
    resubmitFormInstructions: 'Please update the information or attach appropriate document for resubmission.',
    zipInstructions: 'Please enter Zip/Postal Code used when purchased at the dealership',
    zipCode: 'Zip / Postal Code *',
    zipCodeRequired: 'Zip / Postal Code is required',
    vin: '17 digit VIN # *',
    nickname: 'Nickname',
    vinRequired: 'Full 17 character VIN is required',
    vinFormat: 'VIN must be only numbers and letters',
    isOriginalOwner: 'Are you the original owner?',
    isOriginalOwnerRequired: 'Are you the second owner? is required',
    attachmentRequired: 'Please specify if an attachment is needed?',
    documentTypeRequired: 'Document type selection required',
    uploadInstructions: 'Please select a document type to upload a copy of your proof of ownership:  *',
    resubmitUploadInstructions: 'Please select a document type to upload a copy of your proof of ownership:  *',
    uploadControlLabel: 'Proof of Ownership',
    uploadValidationError: 'Proof of ownership documentation is required',
    uploadDocTypeRequired: 'Document type selection required. Make selection and try again.',
    successMessage: 'Success! Your RV registration has been sent to {companyDisplayName} for review.',
    resubmitSuccessMessage: 'Success! Your RV registration has been re-sent to {companyDisplayName} for review.',
    vinNotFoundError1: 'The information you provided is different than what we have on record.',
    vinNotFoundError2: 'Check if the 17-digit VIN was entered correctly',
    vinNotFoundError3:
      'Please use the same information that was provided to the dealer when the RV was originally purchased',
    vinNotFoundError4: 'If the issue persists or you have any questions please contact ',
    vinNotFoundError5: 'for assistance',
  },

  dealerLocator: {
    brand: 'Brand',
    anyBrand: 'Any Brand',
    directions: 'Directions',
    invalidUSPostalCodeError: '* Must be 5 numeric digits',
    invalidCAPostalCodeError: '* Must follow "A1A 1A1" format',
    searchHeader: 'Find RV Dealer Near Me',
    searchHeaderSubText: 'Search by zip code to find dealers close to home.',
    milesAway: 'miles away',
    miles: 'miles',
    kilometersAway: 'km away',
    kilometers: 'km',
    availableBrands: 'Available Brands:',
    email: 'Email',
    phone: 'Phone',
    serviceOnly: 'Service Only',
    website: 'Website',
    noDealerLocations: 'No dealer locations within {distance} {metric} with the above filters.',
    searchInstructions: 'Enter a zip/postal code to search for the nearest dealers.',
    defaultSelectBrandText: 'Any Brand',
  },

  tableCard: {
    searchPlaceholder: 'Search'
  },

  manageVehicles: {
    title: 'My RV',
    addNewRv: 'Add New RV',
    pendingRvs: 'View Pending Rvs',
    vinLabel: 'VIN: ',
    changeImageLabel: 'Change this Image',
    ownersManualLabel: "Owner's Manual",
    serviceInformationLabel: 'Service Information',
    manageUsersLabel: 'Manage Users',
    removeRVLabel: 'Remove this RV',
    updateNicknameLabel: '{action} nickname',
    addAction: 'Add a',
    editAction: 'Edit',
    changeImageTitle: 'Upload a new image',
    uploadControlLabel: 'RV Image',
    removeRVTitle: 'Confirm Remove',
    removeRVConfirm: 'Are you sure you want to remove the "{displayName}" RV from user {userName}',
    removeSuccess: 'RV removed successfully!',
    nicknameChangeSuccess: 'RV nickname successfully changed!',
    imageChangeSuccess: 'RV image successfully updated!',
    pendingRegistrationInfo: '* Full access pending Review'
  },

  manageVehicleUsers: {
    title: 'Manage RV Users',
    inviteUser: 'Invite User',
    email: 'Email *',
    emailRequired: 'Email is required',
    consumerUserInvitationSent: 'Success! An invitation to create an account has been sent to {email}.',
    consumerUserAccessAdded: 'Success! User with email {email} has been added.',
    confirmResendInvite: 'Are you sure you want to resend the invitation email to {email}?',
    resendInvitation: 'Resend Invitation',
    removeAccess: 'Remove Access',
    resendInviteSuccess: 'Invitation email sent to {email}!',
    confirmRemoveAccess: 'Are you sure you want to remove user with email {email} from this RV?',
    removeAccessSuccess: 'Success! User {email} removed from RV access!',
    accountNotRegistered: 'Account not registered',
    accountRegistered: 'Account registered',
  },

  notifications: {
    title: 'Notifications',
    deleteDialogTitle: 'Delete Notification',
    deleteSuccess: 'Delete Success!',
    emptyNotifications: 'Notifications empty'
  },

  serviceInformation: {
    pageTitle: 'Service Information: ',
    makeModelLabel: 'Make/Model: ',
    yearLabel: 'Year: ',
    vinLable: 'Vin: ',
    datePurchaseLabel: 'Date of Purchase: ',
    warrantyStatus: 'Warranty Status: ',
    warrantyStart: 'Warranty Start: ',
    warrantyEnd: 'Warranty End: ',
    partsExpiration: 'Parts Expiration: ',
    serviceExpiration: 'Service Expiration: ',
    supportInfo: 'For Questions about Sales Orders or Claims please Contact your Dealer',
    tabLabels: {
      salesOrders: 'Sales Orders',
      claims: 'Claims',
      recalls: 'Recalls',
    },
    salesOrderLabels: {
      emptyLabel: 'No current sales orders',
      orderNumLabel: 'Order',
      statusLabel: 'Status',
      statusDateLabel: 'Status Date',
      createdDateLabel: 'Created Date',
      deliveryMode: 'Mode of Delivery',
      trackingNumber: 'Tracking Number',
    },
    claimLabels: {
      emptyLabel: 'No current claims',
      claimNumber: 'Claim Number',
      status: 'Status',
      statusDate: 'Status Date',
      createdDate: 'Created Date',
    },
    recallLabels: {
      emptyLabel: 'No current recalls',
      recallId: 'Recall Id',
      name: 'Name',
      type: 'Type',
    },
  },

  pdfViewer: {
    checklist: 'checklist',
    checklists: 'checklists'
  },

  support: {
    title: 'Contact Support',
    hoursOfOperation: 'Hours of Operation:',
    supportInfo: {
      instructions: 'For the fastest service please have the following in hand before contacting customer service:',
      completeVin: 'Complete VIN number',
      mailingAddress: 'Mailing address (Please no P.O. box numbers)',
      daytimePhone: 'Day time phone number',
      privacyStatement: {
        start: '{companyDisplayName} values your privacy and ',
        emphasis: 'promises never to share your personal information. ',
        end: 'It is only used to contact you.',
      },
      support: 'Support'
    },
    myRvInfo: 'Your RV Information:',
    brandSupport: 'Contact Brand Support',
    portalAppInfo: '{portalName} App Info:',
    versionLabel: 'Version',
    versionText: '{version}.{build}',
  },

  pendingRVs: {
    title: 'Pending RVs',
    vin: 'VIN',
    displayName: 'Description',
    registrationDate: 'Submission Date',
    registrationStatus: 'Status',
    reviewedDate: 'Reviewed Date',
    seeComments: 'See Comment',
    resubmit: 'Resubmit',
  },

  podcast: {
    bannerText: 'LAUNCHING LIFE’S JOURNEYS PODCAST',
    podcastContent:
      '<p>Whether you are new to traveling the world one mile at a time, or you have raised a family with thousands of memories made at a campsite…this podcast is all about the people, journeys and stories that are shared.</p><p>Recreational vehicles allow people the ability to travel the world, mile by mile while providing safe shelter and comfortable living quarters when destinations are reached. Willie invites you to join him on his journey with {companyDisplayName}.&nbsp; Whether you are new to traveling the world one mile at a time, or you have raised a family with thousands of memories made at a campsite, this podcast is all about the people, journeys, and stories that are shared.</p><p>You will hear from the following guests on the Where’s Willie Show:</p><ul><li>Celebrities that have unique stories to share on their own life journeys</li><li>Entrepreneur/C-Suite executives sharing their company innovations that you could see on your next journey</li><li>Current RV owners that can share advice, insight, and questions to help make your experience memorable</li><li>Vacation destination hosts, resorts, dining, and more…. inviting you to visit on your life’s journeys.</li></ul><p>“My goal of hosting this show is to share amazing stories of real people and real-life as they are traveling on their own life’s journeys. Every person has a story to share, from both professional experiences and personal.” —William Miller, Host of Where’s Willie?</p><p>Select an episode below to listen now.</p>',
    readMore: 'Read More',
    listenNow: 'Listen Now'
  },

  blogPosts: {
    categoryLabel: 'Topic',
  },

  blogPostDetails: {
    relatedStories: 'Related Stories',
  },

  faq: {
    faqTitle: 'Frequently Asked Questions',
    glossaryTitle: 'RV Glossary'
  },

  /////////////////////////////////////////////////////////////////////////////////
  // Admin

  manageEmails: {
    title: 'Manage Emails'
  },

  manageRoles: {
    title: 'Manage Roles',
    addRole: 'Add Role',
    systemRole: 'System Role',
    permissions: 'Permissions',
    roleNotFound: 'Selected role could not be found',
    deleteConfirm: 'Are you sure you want to delete the "{role}" role?',
    editRole: 'Edit Role',
    createRole: 'Create Role',
    roleName: 'Role Name *',
    roleNameRequired: 'Role Name is requried'
  },

  manageUsers: {
    title: 'Manage Users',
  },

  /////////////////////////////////////////////////////////////////////////////////
  // Shared

  action: 'Action',
  cancel: 'Cancel',
  close: 'Close',
  delete: 'Delete',
  edit: 'Edit',
  error: 'Error',
  errorInstruction: 'Please fix the following errors:',
  failed: 'Action failed',
  goBack: 'Go Back',
  name: 'Name',
  noResults: 'No results',
  OK: 'OK',
  reset: 'Reset',
  submit: 'Submit',
  resubmit: 'Resubmit',
  success: 'Success',
  unexpectedError: 'Unexpected error. Please try again.',
  search: 'Search',
  users: 'Users',
  documents: {
    sizeError: 'Max document size is {maxSizeBytes} MB',
    typeError:
      'Document with extension {fileExtension} is not supported. Supported document types include {supportedExtensions}',
    numberError: 'Only {maxNumber} file(s) supported with upload',
    defaultError: 'An unexpected error occurred uploading your file. Please try again.',
  },
  goBackButtonLabel: 'Back to {routeName}',
  emptyDataMessage: 'No data available'
};
